"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlertButtonStyle = void 0;
const tslib_1 = require("tslib");
const UIHelper_1 = tslib_1.__importDefault(require("../../UIHelper"));
const getAlertButtonStyle = (alerts) => {
    const messageType = UIHelper_1.default.getMessageTypeFromAdaptableAlerts(alerts);
    const messageTypeColor = UIHelper_1.default.getColorByMessageType(messageType);
    const buttonBackground = UIHelper_1.default.getButtonColourForAdaptableAlerts(alerts, messageTypeColor);
    const buttonTextColor = UIHelper_1.default.getButtonTextColourForArrayandMessageType(alerts, messageType);
    return {
        color: buttonTextColor,
        background: buttonBackground,
    };
};
exports.getAlertButtonStyle = getAlertButtonStyle;
